<script>
export default {
  name: 'VNodes',
  props: {
    vnodes: {
      type: [Array, Object],
      default: null
    }
  },
  render() {
    return this.vnodes
  }
}
</script>
